import { registryApi } from '../clients/AxiosClients'

export const getPerfisDeAcesso = () => {
	return registryApi.get('v1/PerfilDeAcesso')
}

export const updatePerfilDeAcesso = (perfilDeAcesso) => {
	return registryApi.put('v1/PerfilDeAcesso', perfilDeAcesso)
}

export const deletePerfilDeAcessoByIdList = (idPerfilDeAcessoList) => {
	return registryApi.delete('v1/PerfilDeAcesso/DeleteByIdList', { data: idPerfilDeAcessoList })
}

export const createPerfilDeAcesso = (perfilDeAcesso) => {
	return registryApi.post('v1/PerfilDeAcesso', perfilDeAcesso)
}

export const getRoles = () => {
	return registryApi.get('v1/roles')
}
